/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { Form } from '@unform/web';

import { Container, Header, ButtonTest } from './styles';

import history from '~/services/history';
import api from '~/services/api';
import ImageInput from '~/pages/Admin/Modules/ImageInput';

export default function Cards() {
  const formRef = useRef(null);
  const { id } = useParams();
  const [subject, setSubject] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [position, setPosition] = useState('');
  const [type, setType] = useState('');
  const [image, setImage] = useState('');

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`/subjects/${id}`);
      setSubject(data);
      setTitle(data.title);
      setDescription(data.description);
      setPosition(data.position);
      setType(data.type);
      setImage(data.file);
    }

    getData();
  }, [id]);

  async function handleSubmitData(e) {
    e.preventDefault();
    try {
      await api.put(`/subjects/${id}`, {
        title,
        description,
        position,
        type,
      });

      return toast.success('Matéria atualizado com sucesso');
    } catch (error) {
      return toast.error('Erro ao atualizar o Matéria');
    }
  }

  async function handleSubmitImage(data) {
    const { file_id } = data;

    try {
      await api.put(`/subjects/${id}`, {
        file_id,
      });

      return toast.success('Imagem da Matéria atualizada com sucesso');
    } catch (error) {
      return toast.error('Erro ao atualizar a Imagem da Matéria');
    }
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/subject')}
        >
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>

        {/* <ButtonTest type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </ButtonTest> */}

        <ButtonTest type="submit" onClick={() => history.push('/challenge')}>
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/jobs')}>
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1>Editar Matéria:</h1>
        <div>
          <p>Título: {subject.title}</p>
          <p>Categoria: {subject.type}</p>
          <p>Posiçāo: {subject.position}</p>
          <p>Descriçāo: {subject.description}</p>
          <a href={`${image.url}`} target="_blank" rel="noopener noreferrer">
            Imagem da Matéria
          </a>
        </div>

        <form action="submit" onSubmit={handleSubmitData}>
          <div className="support">
            <span>Título:</span>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <span>Categoria:</span>
            <input
              type="text"
              value={type}
              onChange={(e) => setType(e.target.value)}
            />
            <span>Posiçāo:</span>
            <input
              type="text"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
            />
            <span>Descriçāo:</span>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <button className="form" type="submit">
            ATUALIZAR DADOS
          </button>
        </form>

        <Form ref={formRef} onSubmit={handleSubmitImage}>
          <div className="image">
            <span>Imagem:</span>
            <ImageInput name="file_id" />
          </div>
          <button className="form" type="submit">
            ATUALIZAR IMAGEM
          </button>
        </Form>
      </Container>
    </>
  );
}
